import styled, { css } from 'styled-components';

export const StarWrapper = styled.span`
  ${({ theme }) => css`
    color: ${theme.color.support.orange.strong};
    margin-left: ${theme.spacing.km1};
  `}
`;

export const Account = styled.div<{ hasAccount: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ hasAccount }) => `${hasAccount ? 'center' : 'flex-end'}`};

  ${({ hasAccount }) =>
    hasAccount &&
    css`
      fuel-button {
        display: none;
      }

      &:hover {
        div:first-child {
          display: none;
        }

        fuel-button {
          display: flex;
          width: 109px;
        }
      }
    `}
`;
